import { apiRequest } from './apiClient';
import {
  AlertasDocumentosResponse,
  AlertaDocumentoStatus,
  RecalculoAlertasResponse,
} from '../types/alertas';
import {
  DocumentosDashboardFilters,
  DocumentosDashboardResponse,
} from '../types/documentosDashboard';

function toQuery(params: Record<string, string | number | undefined>): string {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== '') {
      query.set(key, String(value));
    }
  });

  const serialized = query.toString();
  return serialized ? `?${serialized}` : '';
}

export function listAlertasDocumentos(
  accessToken: string,
  filters: {
    empresaId?: string;
    status?: AlertaDocumentoStatus;
    papel?: string;
    tipoDocumento?: string;
    uf?: string;
    diasVencimento?: number;
    page?: number;
    pageSize?: number;
  }
): Promise<AlertasDocumentosResponse> {
  return apiRequest<AlertasDocumentosResponse>(
    `/alertas-documentos${toQuery({
      ...filters,
      page: filters.page,
      pageSize: filters.pageSize ?? 100,
    })}`,
    accessToken
  );
}

export function listarDashboardDocumentos(
  accessToken: string,
  filters: DocumentosDashboardFilters
): Promise<DocumentosDashboardResponse> {
  return apiRequest<DocumentosDashboardResponse>(
    `/alertas-documentos/dashboard${toQuery({
      empresaId: filters.empresaId,
      papel: filters.papel,
      tipoDocumento: filters.tipoDocumento,
      uf: filters.uf,
      status: filters.status,
      diasVencimento: filters.diasVencimento,
      page: filters.page,
      pageSize: filters.pageSize,
    })}`,
    accessToken
  );
}

export function recalcularAlertasDocumentos(
  accessToken: string,
  diasVencimento: number
): Promise<RecalculoAlertasResponse> {
  return apiRequest<RecalculoAlertasResponse>('/alertas-documentos/recalcular', accessToken, {
    method: 'POST',
    body: JSON.stringify({ diasVencimento }),
  });
}
